import { useEffect, useState } from 'react'

// Services
import ScrapeServices from '../../services/Scrape.services';

// Redux
import { useSelector } from "react-redux";

// Helper
import { getModuleName, getServer } from '../../utils/oneintelligence/OneIntelligenceHelper';
import TrackFeatureServices from '../../services/TrackFeature.services';

const useScrapeKeywords = (refreshList = true) => {
    const [loading, setLoading] = useState(false);
    const [keywords, setKeywords] = useState([]);

    const {
        setup: {
            marketPackage,
            country
        },
    } = useSelector((state) => state.buildTargets);

    const getMarketPackageName = () => marketPackage?.parent?.title || marketPackage?.parent?.name || ""
    // const getModuleName = () => {
    //     if (marketPackage?.code === "icd10") return "ICD-10"
    //     return marketPackage?.title || marketPackage?.name || ""
    // }

    const countryCode = country?.enterpriseCode;
    const packageCode = marketPackage?.parent?.oiCode
    const marketPackageCode = getMarketPackageName();
    const moduleCode = getModuleName();

    const getListKeywords = async () => {
        const { startMonitor, endMonitor } = TrackFeatureServices.getMonitor({ featureKey: "scrapeTopicList" });
        let usedUrl = ""
        const callBackStart = (params, url) => {
            usedUrl = url
            startMonitor(params, { url: usedUrl })
        }
        try {
            setLoading(true);
            const reqData = {
                country_code: countryCode,
                market_package: marketPackageCode,
                module: moduleCode,
                pageNumber: 1,
                itemsInPage: 500,
            }
            const response = await ScrapeServices.getListKeywords(reqData, callBackStart);
            const { keyword_details } = response;
            setKeywords(keyword_details);
            setLoading(false)
            endMonitor(response, { url: usedUrl })
        } catch (error) {
            setKeywords([]);
            setLoading(false)
        }
    }

    const addKeywords = async (keywords = []) => {
        const { startMonitor, endMonitor } = TrackFeatureServices.getMonitor({ featureKey: "scrapeTopic" });
        let usedUrl = ""
        const callBackStart = (params, url) => {
            usedUrl = url
            startMonitor(params, { url: usedUrl })
        }

        const { url, code } = getServer();
        const reqData = {
            country_code: countryCode,
            market_package: marketPackageCode,
            module: moduleCode,
            savant_country_code: code,
            savant_url: url,
            package: packageCode,
            keywords
        }
        const promise = ScrapeServices.addKeywords(reqData, callBackStart);
        promise.then((response) => {
            endMonitor(response, { url: usedUrl })
        })
        return await promise;
    }

    useEffect(() => {
        if (moduleCode && refreshList) getListKeywords()
    }, [moduleCode])

    return { loading, keywords, addKeywords, getListKeywords }
}

export default useScrapeKeywords